import React from 'react';
export var defaultNavigationContext = {
  theme: 'lightBackground',
  transparent: false
};
export var NavigationContext = /*#__PURE__*/React.createContext(defaultNavigationContext);